import React from 'react';

import { Panel, PanelType } from 'office-ui-fabric-react/lib/Panel';

import CSVReader from "react-csv-reader";
import { Button } from 'office-ui-fabric-react/lib/Button';
import HttpService from '../service/HttpService';

export default class ImportPolicies extends React.Component {
  constructor( props ) {
    super( props );

    this.state = {
      data: null,
      summary: []
    }
  }

  fileLoadedHandler = data => {
    this.setState({data: data})
  }

  checkClient = ( client ) => {
    let exists = false;

    this.props.clients.forEach( element => {
      if( element.documentNumber == client ) {
        exists = true;

        return;
      }
    });

    return exists;
  }

  checkCompany = ( company ) => {
    let exists = false;

    this.props.companies.forEach( element => {
      if( element.name == company ) {
        exists = true;

        return;
      }
    });

    return exists;
  }

  checkPolicy = ( company, policy ) => {
    let exists = false;

    this.props.policies.forEach( element => {
      if( element.policy_number == policy && element.company_name == company ) {
        exists = true;

        return;
      }
    });

    return exists;
  }

  checkType = ( type ) => {
    let exists = false;

    this.props.types.forEach( element => {
      if( element.name.trim() == type.trim() ) {
        exists = true;
        return;
      }
    });

    return exists;
  }

  runProcess = ( summary ) => {
    let items = [];
    let http = new HttpService();

    http.POST( '/insurance/import', { data: summary } )
      .then( response => {
        this.props.onComplete( items );
      })
      .catch( error => {
        alert( error );
      });
  }

  render() {
    let { summary } = this.state;

    return (
      <Panel
          isOpen={this.props.isOpen}
          type={PanelType.smallFluid}
          onDismiss={this.props.onDismiss}
          headerText="Importar Pólizas"
          closeButtonAriaLabel="Close"
        >
        <p>El formato de archivo de importación deberá ser CSV con el formato indicado en el modelo.</p>

        <p><Button text="Descargar Modelo" onClick={() => {
          window.open( '/assets/files/model.csv' );
        }} /></p>
        
        <div style={{ marginTop: 20 }}>
          <CSVReader
            label="Seleccionar archivo para subir"
            parserOptions={{
              header: true,
              trimHeaders: true
            }}
            onFileLoaded={this.fileLoadedHandler}
            onError={console.error}
          />
        </div>
        { this.state.data && 
        <table cellPadding="10">
          <thead>
            <tr>
              <th>Cliente</th>
              <th>Número póliza</th>
              <th>Compañia</th>
              <th>Tipo Póliza</th>
              <th>Inicio Covertura</th>
              <th>Fin Covertura</th>
              <th>Referencia</th>
              <th>Estado</th>
            </tr>
          </thead>
          <tbody>
            { this.state.data.map( ( item, index ) => {
              if( item.client_document ) {
                let status = 'IMPORTAR PÓLIZA';
                let style = 'ms-bgColor-green';
                let text = ' ms-fontColor-white';
                let _import = true;

                if( !this.checkClient( item.client_document ) ) {
                  status = 'IMPORTAR CLIENTE | IMPORTAR PÓLIZA';
                  style = ' ms-bgColor-yellow'; 
                  text = ' ms-fontColor-black';
                } else {
                  if( !this.checkCompany( item.policy_company ) ) {
                    status = 'IGNORAR. NO EXISTE LA COMPAÑIA ASEGURADORA';
                    style = 'ms-bgColor-red';
                    text = ' ms-fontColor-white';
                    _import = false;
                  } else {
                    if( !this.checkType( item.policy_type ) ) {
                      status = 'IGNORAR: NO EXISTE EL TIPO DE PÓLIZA';
                      style = 'ms-bgColor-red';
                      text = ' ms-fontColor-white';
                      _import = false;
                    } else {
                      if( this.checkPolicy( item.policy_company, item.policy_number ) ) {
                        status = 'IGNORAR. YA EXISTE LA PÓLIZA';
                        style = 'ms-bgColor-red';
                        text = ' ms-fontColor-white';
                        _import = false;
                      }
                    }
                  }
                }

                if( _import ) {
                  summary.push( item );
                }

                return <tr key={ "row" + index } className={ style + text }>
                  <td>{ item.client_document } - { item.client_name }</td>
                  <td>{ item.policy_number }</td>
                  <td>{ item.policy_company }</td>
                  <td>{ item.policy_type }</td>
                  <td>{ item.policy_coverage_start }</td>
                  <td>{ item.policy_coverage_end }</td>
                  <td>{ item.policy_reference }</td>
                  <td>{ status }</td>
                </tr>
              }
            }) }
          </tbody>
          <tfoot>
            <tr>
              <td colSpan="6">¿Confirma continuar con la operación?<br/> <span className="ms-fontColor-red">Una vez iniciado el proceso no debe ser detenido. No cierre la página hasta que el sistema confirme que finalizó la operación!</span></td>
              <td><Button text="Importar" onClick={ () => {
                this.runProcess( summary );
              } }/></td>
            </tr>
          </tfoot>
        </table>
        }
        { this.state.data && 
          <p className="ms-fontColor-red">LA DOCUMENTACIÓN DEBERÁ ADJUNTARSE EN FORMA MANUAL EN CADA PÓLIZA</p>
        }
      </Panel>
    )
  }
}


// WEBPACK FOOTER //
// ./src/component/ImportPolicies.jsx